<template>
  <div class="p-contest-form__form-container">
    <form v-if="isLoggedIn" autocomplete="off" @submit.prevent="onSubmitForm">
      <Loader v-if="isLoading"></Loader>
      <!-- <Alert
        v-if="!isLoading && errorMsgs.length"
        key="submit-errors"
        dismiss-by-native=""
        type="danger"
        :messages="errorMsgs"
        @close="removeErrors"></Alert> -->

      <div class="b-block b-block--transparent b-block--sm-pad">
        <div>
          <div class="b-block__form-section">
            <div class="b-block__title">{{ dictionary.fieldsHeaderLabel }}</div>
            <div v-if="user?.firstName" class="form-floating">
              <input
                id="firstName"
                :value="user.firstName"
                name="firstName"
                type="text"
                class="form-control"
                disabled />
              <label for="firstName" class="form-label">
                {{ dictionary.fieldFirstNameLabel }}
              </label>
            </div>
            <div v-if="user?.lastName" class="form-floating">
              <input
                id="lastName"
                :value="user.lastName"
                name="lastName"
                type="text"
                class="form-control"
                disabled />
              <label for="lastName" class="form-label">
                {{ dictionary.fieldLastNameLabel }}
              </label>
            </div>
            <div v-if="user?.email" class="form-floating">
              <input
                id="email"
                :value="user.email"
                name="email"
                type="text"
                class="form-control"
                disabled />
              <label for="email" class="form-label">
                {{ dictionary.fieldEmailLabel }}
              </label>
            </div>
            <!-- Dynamically render form fields -->
            <div
              v-for="(field, index) in formFields"
              :key="index"
              class="form-floating">
              <!-- Text Input -->
              <input
                v-if="field.type === 'text' || field.type === 'email'"
                :id="field.id"
                v-model="form[field.id]"
                :name="field.name"
                type="text"
                class="form-control"
                maxlength="50"
                :placeholder="field.name"
                :class="{
                  'form-control--error':
                    v$[field.id]?.$dirty && v$[field.id]?.$invalid,
                }"
                @blur="v$[field.id]?.$touch()" />

              <!-- Numeric Input -->
              <input
                v-if="field.type === 'numeric'"
                :id="field.id"
                v-model="form[field.id]"
                :name="field.name"
                type="text"
                class="form-control"
                maxlength="50"
                :placeholder="field.name"
                :class="{
                  'form-control--error':
                    v$[field.id]?.$dirty && v$[field.id]?.$invalid,
                }"
                @input="sanitizeNumeric(field.id)"
                @blur="v$[field.id]?.$touch()" />

              <!-- Dropdown Input -->
              <select
                v-if="field.type === 'dropdown'"
                :id="field.id"
                v-model="form[field.id]"
                :name="field.name"
                class="form-select"
                :class="{
                  'form-select--error':
                    v$[field.id]?.$dirty && v$[field.id]?.$invalid,
                }"
                @blur="v$[field.id]?.$touch()">
                <option disabled value="">{{ field.placeholder }}</option>
                <option
                  v-for="(option, optionIndex) in field.options"
                  :key="optionIndex"
                  :value="option.value">
                  {{ option.text }}
                </option>
              </select>

              <label :for="field.id" class="form-label">
                {{ field.name }}
              </label>

              <!-- Field validation errors -->
              <div
                v-if="v$[field.id]?.$dirty && v$[field.id]?.$invalid"
                class="field-validation-error">
                <template v-if="v$[field.id]?.required?.$invalid">
                  <template v-if="field.type === 'numeric'">
                    {{ dictionary.fieldRequiredNumeric }}
                  </template>
                  <template v-else>
                    {{ dictionary.fieldRequired }}
                  </template>
                </template>
                <template v-else-if="v$[field.id]?.minLength?.$invalid">
                  {{ field.name }} {{ dictionary.fieldLength }}
                </template>
                <template v-else-if="v$[field.id]?.maxLength?.$invalid">
                  {{ field.name }} {{ dictionary.fieldLength }}
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="b-block__checkboxes">
        <div class="custom-chck custom-chck--additional-style">
          <input
            id="accept-terms"
            v-model="form.acceptTerms"
            type="checkbox"
            name="accept-terms"
            :class="{ 'form-control--error': v$.acceptTerms.$error }"
            @click="v$.acceptTerms.$touch()" />

          <label for="accept-terms">
            <span class="custom-chck__span">
              <div class="custom-chck__text">
                <em>{{ dictionary.acceptTermsTitle }}</em>
                <div
                  v-if="dictionary.acceptTermsDesc"
                  v-html="dictionary.acceptTermsDesc"></div>
              </div>
            </span>
          </label>

          <!-- validations -->
          <template v-if="v$.acceptTerms.$error">
            <div
              v-if="v$.acceptTerms.required.$invalid"
              class="field-validation-error">
              {{ dictionary.acceptTermsRequired }}
            </div>
          </template>
        </div>
      </div>

      <div class="b-block__form-btn">
        <button
          type="submit"
          class="p-contact__submit-btn"
          :disabled="v$.$invalid">
          <span>{{ dictionary.submitBtnLabel }}</span>
        </button>
      </div>
    </form>

    <ModalOverlay
      v-model="showErrorModal"
      no-close-backdrop
      background-class="b-pop-up--alert-success b-pop-up__holder"
      header-background-class="b-pop-up__header"
      @close="() => toggleErrorModal(false)">
      <template #header>
        <div class="b-pop-up__header__title">
          {{ dictionary.errorModalHeader }}
        </div>
      </template>
      <template #body>
        <div class="b-pop-up__alert-success__content">
          <div
            class="b-pop-up__alert-success__icon b-pop-up__alert-success__icon--exclamation"></div>
          <div class="b-pop-up__alert-success__content__container">
            <div class="b-pop-up__alert-success__title">
              <!-- {{ dictionary.errorModalText }} -->
              {{ errorMsgs[0] }}
            </div>
            <div class="b-pop-up__alert-success__text">
              {{ errorMsgs[1] }}
              <!-- {{ dictionary.errorModalSubtext }} -->
            </div>
            <button
              type="button"
              class="b-pop-up__alert-success__cta"
              @click="() => toggleErrorModal(false)">
              {{ dictionary.errorModalClose }}
            </button>
          </div>
        </div>
      </template>
    </ModalOverlay>
  </div>
</template>

<script setup>
import {
  computed,
  getCurrentInstance,
  nextTick,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
} from 'vue'

import * as lib from '../../lib/lib'
import Loader from './../components/Shared/Loader.vue'
import { useVuelidate } from '@vuelidate/core'
import ModalOverlay from './../components/ModalOverlay.vue'
import postRequestHandler from '../../lib/postRequestHandler'
import getErrorMessage from '../../lib/getErrorMessage'
import { maxLength, required, sameAs } from '@vuelidate/validators'

const { proxy } = getCurrentInstance()
const configuration = proxy.configuration
const dictionary = proxy.dictionary

const isLoading = ref(true)
const isLoggedIn = ref(false)
const showErrorModal = ref(false)
const errorMsgs = ref([])
const contestId = ref('')
const formFields = ref([])
const user = ref([])

const form = reactive({
  acceptTerms: false,
})

// initialize form keys once we have fields
function initForm(fields) {
  fields.forEach((field) => {
    form[field.id] = ''
  })
}

// Build validation rules
const rules = computed(() => {
  const validationRules = {
    acceptTerms: {
      required: sameAs(true),
    },
  }
  formFields.value.forEach((field) => {
    if (field.type === 'dropdown') {
      validationRules[field.id] = { required }
    } else {
      validationRules[field.id] = { required, maxLength: maxLength(50) }
    }
  })
  return validationRules
})

// Create Vuelidate instance
const v$ = useVuelidate(rules, form)

onMounted(() => {
  const { fields, contestInfo, userData } = lib.getData(
    'contestRegistrationFormData'
  )

  isLoggedIn.value = configuration.isLoggedIn
  formFields.value = fields
  contestId.value = configuration.contestId
  user.value = userData
  lib.checkCaptcha(() => (isLoading.value = false))
  initForm(fields)

  document.addEventListener('login-was-held', (e) => {
    if (e.detail.accountData) {
      isLoggedIn.value = true
      window.location.reload()
    }
  })

  nextTick(() => {
    v$.value.$reset()
    if (!isLoggedIn.value) {
      jQuery(document).trigger('login-clicked', {
        action: 'contestLogin',
        contestInfo,
      })
    }

    formFields.value.forEach((field) => {
      const fieldState = v$.value[field.id]
      if (fieldState) {
        fieldState?.$touch()
      }
    })
  })
})

onBeforeUnmount(() => {
  document.removeEventListener('login-was-held')
})

// methods
function sanitizeNumeric(id) {
  form[id] = String(form[id]).replace(/[^0-9]/g, '')
}

function removeErrors() {
  errorMsgs.value = []
}

function toggleErrorModal(show) {
  showErrorModal.value = show
}

async function onSubmitForm() {
  v$.value.$touch()
  if (isLoading.value) {
    return
  }
  if (v$.$invalid) {
    await nextTick()
    lib.scrollToValidation()
    return
  }

  removeErrors()
  isLoading.value = true

  const fieldsPayload = Object.fromEntries(
    formFields.value.map((field) => {
      if (field.type === 'dropdown') {
        const opt = field.options.find((o) => o.value === form[field.id])
        return [field.id, String(opt?.text || '')]
      }
      return [field.id, String(form[field.id])]
    })
  )

  const postData = {
    userSessionId: configuration.userSessionId,
    acceptTerms: form.acceptTerms,
    language: document.documentElement.lang,
    contestId: contestId.value,
    fields: fieldsPayload,
  }

  await postRequestHandler({
    postData,
    endpoint: configuration.endpointSubmitData,
    successCallback: handleSuccess,
    errorCallback: handleError,
    refreshTokenHandler: configuration.refresh,
    captchaAction: configuration.startCaptchaAction,
  })
}

function handleSuccess(response) {
  isLoading.value = false
  formFields.value.forEach((field) => (form[field.id] = ''))
  form.acceptTerms = false
  v$.value.$reset()
  if (response.data.redirectUrl) {
    window.location.href = response.data.redirectUrl
  }
}

function handleError(messages) {
  isLoading.value = false
  errorMsgs.value = getErrorMessage(messages, dictionary.defaultErrorMessage)
  toggleErrorModal(true)
  nextTick(() => {
    // lib.scrollToError()
  })
}
</script>
